// extracted by mini-css-extract-plugin
module.exports = {"link":"organizationalStructureTooltip_link__35b5i"};